import script from "./Steering_wheel.vue?vue&type=script&setup=true&lang=js"
export * from "./Steering_wheel.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__